import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer.js";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.svg";
import Appointment from "../../components/Appointment/Appointment.js";

const AppointmentPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} />
      <PageTitle pageTitle={"Appointment"} pagesub={"Appointment"} />
      <Appointment />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AppointmentPage;
